<div class="modal-backdrop" [style.zIndex]="1000 + index" (click)="close()">
  <div class="modal" (click)="$event.stopPropagation()">
    <button class="modal-close" aria-label="Close" (click)="close()">
      <i class="fas fa-xmark"></i>
    </button>
    <ng-template #dialogContainer></ng-template>
  </div>
</div>
